import { GlobalService } from '@23degrees/shared/services/global';
import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IconsService {
  private readonly assetsUrl = 'https://23scripts.b-cdn.net/assets/svg';
  private readonly localUrl = '/assets/svg';

  /**
   * Constructor
   */
  constructor() {
    
    const domSanitizer = inject(DomSanitizer);
    const matIconRegistry = inject(MatIconRegistry);
    const globalService = inject(GlobalService);
    const baseUrl = globalService.isServer() ? this.assetsUrl : this.localUrl; // this._globalService.baseUrl();

    try {
      matIconRegistry.addSvgIconSetInNamespace('mat_outline', domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/material-outline.svg`));
      matIconRegistry.addSvgIconSetInNamespace('mat_solid', domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/material-solid.svg`));
      matIconRegistry.addSvgIconSetInNamespace('feather', domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/feather.svg`));
      matIconRegistry.addSvgIconSetInNamespace('heroicons_outline', domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/heroicons-outline.svg`));
      matIconRegistry.addSvgIconSetInNamespace('heroicons_solid', domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/heroicons-solid.svg`));
      matIconRegistry.addSvgIcon('23', domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/23-logo.svg`));
      matIconRegistry.addSvgIcon('23-full', domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/23-logo-full.svg`));

    } catch (e) {
      console.error('[Mat Icon Registry failed]', e);
    }
  }
}
